<template>
  <v-dialog v-model="dialog" max-width="900" style="overflow: hidden !important;">
    <v-card>
      <v-card-title>
        Demo Proje Sözleşmesi
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container">
          <div v-html="demoProjectHTML"></div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="row">
        <v-checkbox dense class="me-3" label="Okudum, Onaylıyorum" v-model="contractApproved"></v-checkbox>
        </div>
        <v-spacer></v-spacer>
        <v-btn  color="primary" :disabled="!contractApproved" @click="sendApproveOrder()" >Gönder</v-btn>
<!--        <b-form-checkbox-->
<!--            class="form-check"-->
<!--            id="customControlInline"-->
<!--            name="checkbox-1"-->
<!--            value="accepted"-->
<!--            unchecked-value="not_accepted"-->
<!--        >-->
<!--          Onayladım-->
<!--        </b-form-checkbox>-->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "DemoProjectDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    order: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      dialog: false,
      contractApproved: false,
    };
  },
  computed: {
   ...mapState("order",["demoProjectHTML"]),
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    sendApproveOrder() {
      this.$parent._approveOrder(this.order);
      this.closeDialog();
    }
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
    },

    showDialog: function (newVal) {
      this.dialog = newVal;
    },
  }
}
</script>

<style scoped>

</style>